import { compose } from 'recompose';

import TabNavView from './TabNavView';

export default compose()(TabNavView);
